import { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { BasicTabs } from '@/components/shared/BasicTabs';
import { WorklogsTemplateForm } from './WorklogsTemplateForm';
import { CostLoggingTemplateForm } from './CostLoggingTemplateForm';
import { QaqcTemplateForm } from './QaqcTemplateForm';
import { workpackTabStyles, FloatingLine } from './styles';

type LogsTemplateFormProps = {
  structureId: string;
  emptyForm: boolean;
  handleEmptyForm: (value: boolean) => void;
};

export const LogsTemplateForm = ({
  structureId,
  emptyForm,
  handleEmptyForm,
}: LogsTemplateFormProps) => {
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const handleTabChange = (selectedTabIndex: number) => {
    setSelectedTab(selectedTabIndex);
  };

  const tabs = useMemo(() => {
    return [
      {
        index: 0,
        label: 'Worklogs',
        component: (
          <WorklogsTemplateForm
            emptyForm={emptyForm}
            handleEmptyForm={handleEmptyForm}
            structureId={structureId}
          />
        ),
      },
      {
        index: 1,
        label: (
          <Box component="span" sx={{ opacity: 0.6 }}>
            Cost Logging
          </Box>
        ),
        component: <CostLoggingTemplateForm />,
        disabled: true,
        tooltip: 'Cost Logging will be implemented later',
        testid: 'cost-logging-tab',
      },
      {
        index: 2,
        label: (
          <Box component="span" sx={{ opacity: 0.6 }}>
            QA/QC
          </Box>
        ),
        component: <QaqcTemplateForm />,
        disabled: true,
        tooltip: 'QA/QC will be implemented later',
        testid: 'qaqc-tab',
      },
    ];
  }, [structureId, emptyForm, handleEmptyForm]);

  return (
    <Box>
      <BasicTabs
        tabs={tabs}
        selectedTab={selectedTab}
        changeTab={handleTabChange}
        tabsStyles={workpackTabStyles}
        customSeperator={<FloatingLine />}
        renderingStrategy="eager"
      />
    </Box>
  );
};
